import localStorageEx from 'bundles/common/utils/localStorageEx';

export default function persistingCounter(key: string, initialValue: number) {
  const get = (): number => {
    return localStorageEx.getItem<number>(
      key,
      (storedCount: string) => {
        let val = 0;
        try {
          val = Number(storedCount);
        } catch {
          val = 0;
        }
        return val;
      },
      initialValue
    );
  };

  const set = (value: number) => {
    localStorageEx.setItem(key, value, String);
  };

  const increment = (): number => {
    const count = get();
    const nextIncrement = count + 1;
    set(nextIncrement);
    return nextIncrement;
  };

  return {
    get,
    set,
    increment,
  };
}
